import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
@Injectable({
  providedIn: 'root',
})
export class SecureGuard implements CanActivate {
  authService = inject(AuthService);
  router = inject(Router);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log("<<<<  aqui secure >>>>");
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['creator']);
      return false;
    }
    return true;
  }
}
